exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".actions__btn--confirm{color:#4db6ac !important}.actions__text--limit{color:red !important;font-weight:bold !important}", "", {"version":3,"sources":["/home/webuser/bdr-managers/releases/30/spa/src/pages/sales/actions/Actions.scss"],"names":[],"mappings":"AAEI,uBACE,wBAAA,CAGJ,sBACE,qBACA,2BAAA,CAAA","file":"Actions.scss?vue&type=style&index=0&lang=scss&","sourcesContent":[".actions {\n  &__btn {\n    &--confirm {\n      color: #4db6ac!important;\n    }\n  }\n  &__text--limit {\n    color: red!important;\n    font-weight: bold!important;\n  }\n}\n"],"sourceRoot":""}]);

// exports
